export default "__VITE_PUBLIC_ASSET__8826de2b__"